import makeStyles from '@mui/styles/makeStyles';
import { type PageResponse } from '@on3/api';
import type { IGenericPageProps } from '@on3/ui-lib/api/schema/custom-contracts';
import { useAuth } from '@on3/ui-lib/contexts/AuthProvider';
import { cmsUrl } from '@on3/ui-lib/utils/api';
import {
  AboutBlockMenu,
  InternalBlockMenu,
} from '@public/components/Menu/InternalBlockMenu';
import { Text } from '@public/components/UI/Typography/Text';
import clsx from 'clsx';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

import styles from './StaticPage.module.scss';

export interface PageProps extends IGenericPageProps {
  staticPage: PageResponse | null;
}

interface IPageResponse {
  data: PageResponse;
}

const useStyles = makeStyles((theme) => ({
  svg: {
    '& path': {
      fill: theme.palette.primary.main,
    },
  },
  body: {
    '& a': {
      color: theme.palette.primary.main,
    },
  },
}));

export const StaticPage = ({ data }: IPageResponse) => {
  const { key, title, body } = data;
  const classes = useStyles();
  const { hasArticleEditAccess } = useAuth();
  const router = useRouter();
  const isAdvertisePage = router.asPath === '/page/advertise/';

  const markup = useCallback(() => {
    return { __html: body || '' };
  }, [body]);

  const editLink = `${cmsUrl}/wp-admin/post.php?post=${key}&action=edit`;

  return (
    <div>
      {key === 1678232 && (
        <Head>
          <link
            href="https://feeds.megaphone.fm/andy-staples"
            rel="alternate"
            title="Andy Staples Podcast"
            type="application/rss+xmI"
          />
        </Head>
      )}
      <article>
        {hasArticleEditAccess() && <a href={editLink}>Edit Article</a>}
        {isAdvertisePage && <InternalBlockMenu list={AboutBlockMenu} />}
        <header>
          <Text className={styles.heading} variant="h1">
            {title}
          </Text>
        </header>
        <div>
          <div
            className={clsx(styles.body, classes.body)}
            dangerouslySetInnerHTML={markup()}
          />
        </div>
      </article>
    </div>
  );
};
